import { createStore } from 'vuex';
import { setToken, getToken } from '../service/cookie';

export default createStore({
  state: {
    currentBatch: null,
    isSpecific: false,
    dicOptions: {
      areaVos: [],
      degree_type: [],
      hr_countries: [],
      hr_education: [],
      hr_experience: [],
      hr_national: [],
      hr_political: [],
      hr_relations: [],
      hr_sex: [],
      hr_marry: [],
      hr_health: [],
      hr_adjustment: [],
    },
    userInfo: null,
    token: getToken(),
    showLogin: false,
    isMobile: false,
  },
  mutations: {
    // 设置当前批次
    SET_CURRENTBATCH: (state, playload) => {
      state.currentBatch = playload;
      state.isSpecific = playload?.type == 1 || false;
    },
    SET_USERINFO: (state, playload) => {
      if (!playload) {
        state.userInfo = null;
      } else {
        state.userInfo = Object.assign({}, state.userInfo, playload);
      }
    },
    SET_TOKEN: (state, playload) => {
      setToken(playload);
      state.token = playload;
    },
    SET_DICOPTIONS: (state, playload) => {
      state.dicOptions = Object.assign({}, state.dicOptions, playload);
    },
    SET_SHOWLOGIN: (state, playload) => {
      state.showLogin = playload;
    },
    SET_ISMOBILE: (state, playload) => {
      state.isMobile = playload;
    },
  },
  actions: {},
  modules: {},
});
